/* eslint-disable */
export const setActiveSection = (state, activeSection) => {
  state.activeSection = activeSection;
  state.activeSectionLink = activeSection;
};

export const setActiveSectionLink = (state, activeSectionLink) => {
  state.activeSectionLink = activeSectionLink;
};

export const setScrollingState = (state, isScrolling) => {
  state.isScrolling = isScrolling;
};
